var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppContent',[_c('div',{staticClass:"tvtime-importer-page"},[_c(_setup.TvtimeImporter)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }